import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import actions from 'redux/actions';
import Loading from 'components/Loading';
import tracking from 'helpers/tracking';

const { deleteCard } = actions;

const SubmitDeleteCard = (props) => {
  const dispatch = useDispatch();
  const { isOpen, toggle, className, card } = props;
  const { id, last4 } = card;

  return (
    <Formik
      initialValues={{}}
      onSubmit={(values, { setSubmitting }) => {
        tracking.trackEvent('payment/delete-card');
        dispatch(deleteCard({ cardId: id, setSubmitting, toggle }));
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Modal isOpen={isOpen} toggle={toggle} className={className}>
          <form onSubmit={handleSubmit}>
            <ModalHeader toggle={toggle}>Delete This Card</ModalHeader>
            <ModalBody>
              <p>Deleting it means you won't be able to use this payment method!</p>
              Do you still want to <strong>DELETE * * * * * * * * {last4}</strong>?
            </ModalBody>
            <ModalFooter>
              <button
                type='submit'
                className={`btn ${isSubmitting ? 'btn-outline-danger' : 'btn-danger'}`}
              >
                {isSubmitting ? <Loading color='danger' /> : 'Delete'}
              </button>
              <button type='button' className='btn' onClick={toggle}>
                Close
              </button>
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  );
};

export default React.memo(SubmitDeleteCard);
